import debounce from 'lodash.debounce'
import { createContext, useContext, useEffect, useState } from 'react'

const DeviceContext = createContext<any>(null)

export const DeviceTypeProvider = ({ children }: { children: React.ReactNode }) => {
  const [deviceType, setDeviceType] = useState<'mobile' | 'tablet' | 'laptop'>('laptop')
  const [deviceWidth, setDeviceWidth] = useState<number>(window.innerWidth)
  const handleWindowResize = debounce(() => {
    setDeviceWidth(window.innerWidth)
    if (window?.innerWidth <= 600) {
      setDeviceType('mobile')
      return
    }
    if (window?.innerWidth < 900) {
      setDeviceType('tablet')
      return
    }
    if (window?.innerWidth > 900) {
      setDeviceType('laptop')
      return
    }
  }, 100)

  useEffect(() => {
    handleWindowResize()
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return <DeviceContext.Provider value={{ deviceType, deviceWidth }}>{children}</DeviceContext.Provider>
}

export const useDeviceContext = () => useContext<IUseData>(DeviceContext)

interface IUseData {
  deviceType: 'mobile' | 'tablet' | 'laptop'
  deviceWidth: number
}
